import { typeofbacteria_oms } from './pdfScoreConfig_oms.js';

// Mapping from full names to abbreviated names for oms format
const bacteriaNameMapping_oms = {
    // Harmful bacteria
    'Blautia genus': 'Blautia genus',
    'Firmicutes phylum': 'Firmicutes phylum',
    'Ruminococcus obeum': 'R. obeum',

    // Core bacteria
    'Akkermansia muciniphila': 'A. muciniphila',
    'Bacteroidetes phylum': 'Bacteroidetes phylum',
    'Faecalibacterium prausnitzii': 'F. prausnitzii',
    
    // Beneficial bacteria
    'Bifidobacterium bifidum': 'B. bifidum',
    'Lactobacillus gasseri': 'L. gasseri',
    'Lactobacillus paracasei': 'L. paracasei',
    'Lactobacillus rhamnosus': 'L. rhamnosus',
    'Lactobacillus reuteri': 'L. reuteri'
};

// Configuration for displaying beneficial bacteria names when they are deficient or slightly deficient
export const pdfTextPreciseConfig_oms = {
    // Configuration for beneficial bacteria deficiency display
    beneficial_bacteria_deficiency: [
        {
            page: 14,
            version: 'eng',
            Xpostext: 83,
            Ypostext: 485,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 14,
            version: 'eng',
            Xpostext: 290,
            Ypostext: 302,
            fontsize: 10,
            maxWidth: 210,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 14,
            version: 'eng',
            Xpostext: 287,
            Ypostext: 665,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 83,
            Ypostext: 490,
            fontsize: 10,
            maxWidth: 240,
            condition: 'beneficial_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 290,
            Ypostext: 310,
            fontsize: 10,
            maxWidth: 210,
            condition: 'core_bacteria',
            target_labels: ['Deficient', 'Slightly Deficient'],
            description: ''
        },
        {
            page: 13,
            version: 'thai',
            Xpostext: 287,
            Ypostext: 672,
            fontsize: 10,
            maxWidth: 240,
            condition: 'harmful_bacteria',
            target_labels: ['Excessive', 'Slightly Excessive'],
            description: ''
        },
    ]
};

// Helper function to get deficient beneficial bacteria names
export const getDeficientBacteriaNames = (bacteriaResults, bacteriaType = 'beneficial_bacteria', targetLabels = ['Deficient', 'Slightly Deficient']) => {
    const bacteriaList = typeofbacteria_oms[bacteriaType] || [];
    const deficientBacteria = [];

    bacteriaList.forEach(bacteriaName => {
        const result = bacteriaResults[bacteriaName];
        if (result && targetLabels.includes(result.label)) {
            deficientBacteria.push(bacteriaName);
        }
    });

    return deficientBacteria;
};

// Helper function to format bacteria names for display with abbreviation mapping
export const formatBacteriaNames = (bacteriaNames) => {
    if (bacteriaNames.length === 0) {
        return 'None';
    }
    
    // Map full names to abbreviated names
    const abbreviatedNames = bacteriaNames.map(name => bacteriaNameMapping_oms[name] || name);
    return abbreviatedNames.join(', ');
};

// Helper function to get configuration for specific page and language
export const getTextConfigForPage = (pageNumber, language = 'eng') => {
    const configs = pdfTextPreciseConfig_oms.beneficial_bacteria_deficiency;
    return configs.find(config => config.page === pageNumber && config.version === language);
};
